export default "__VITE_ASSET__DqCI6pO$__"